/**
 * Manages registered properties (dimensions and values) that are sent with all events
 */
export default class RegisteredPropertiesStore {
    constructor(coreStorage) {
        this.coreStorage = coreStorage;
        this.properties = this.loadFromStorage();
    }
    /**
     * Load registered properties from storage
     */
    loadFromStorage() {
        try {
            const stored = this.coreStorage.getAppAnalyticsRegisteredProperties();
            return stored ? JSON.parse(stored) : null;
        }
        catch (e) {
            return null;
        }
    }
    /**
     * Register properties to be sent with all events
     * @param dimensions - Object of key:value dimensions
     * @param values - Object of key:value values
     */
    register(dimensions = {}, values = {}) {
        this.properties = { dimensions, values };
        try {
            this.coreStorage.setAppAnalyticsRegisteredProperties(JSON.stringify(this.properties));
        }
        catch (e) {
            // Storage might fail in some environments
        }
    }
    /**
     * Register properties only if not already registered
     * @param dimensions - Object of key:value dimensions
     * @param values - Object of key:value values
     */
    registerOnce(dimensions, values) {
        if (!this.properties) {
            this.register(dimensions, values);
        }
    }
    /**
     * Unregister all properties
     */
    unregister() {
        this.properties = null;
        try {
            this.coreStorage.removeAppAnalyticsRegisteredProperties();
        }
        catch (e) {
            // Storage might fail in some environments
        }
    }
    /**
     * Get current registered properties
     */
    get() {
        return this.properties;
    }
    /**
     * Refresh properties from storage (useful after external changes)
     */
    refresh() {
        this.properties = this.loadFromStorage();
    }
}
